import { gql } from '@apollo/client';

export const GET_MY_ELEMENTS_SIDEBAR_INCOMPLETE_REPORTS_DATA = gql`
  query GetMyElementsSideBarIncompleteReportsData($volunteerId: String!) {
    vm {
      volunteer(volunteerId: $volunteerId) {
        activityEnrolments {
          activity {
            activityId
            program {
              dateDeleted
              dateSuspended
            }
          }
        }
        rosterings {
          publishedRosteringId
          publishedRoster {
            activityDate
            activity {
              activityId
              program {
                dateDeleted
                dateSuspended
              }
            }
          }
        }
        isCheckedIn
        checkedIn {
          CICOId
          checkIn
          checkOut
          sessionReport {
            session {
              sessionId
            }
            activityReport {
              activityDate
                activity {
                  __typename
                  activityId
                  startTime
                  endTime
                  name
                  hasOpenRoster
                  activityRemoteLocation {
                    activityRemoteLocationId
                  }
                  activityLocation {
                    placesAddress {
                        placesId
                        description
                        formatted
                    }
                  }
                  program {
                    programId
                    name
                  }
                  sessions(includeOneOff: true) {
                    sessionId
                    name
                    startTime
                    endTime
                    description
                    isFlexible
                    isOneOff
                    activityDate
                    currentFlexibleInstances {
                      flexibleSessionInstanceId
                      sessionDate
                      startTime
                      endTime
                      name
                    }
                    activityLocation {
                      placesAddress {
                        placesId
                        description
                        formatted
                      }
                    }
                  }
                }
            }
          }
        }
      }
    }
  }
`;

export const GET_MY_ELEMENTS_SIDEBAR_INCOMPLETE_REPORTS_COUNT = gql`
  query GetMyElementsSideBarIncompleteReportsCount($activityIds: [String!], $from: Date!, $until: Date!) {
    vm {
      incompleteActivityReports(activityIds: $activityIds) {
        activityId
        occurrences(from: $from, until: $until)
      }
    }
  }
`;
